import type { ScreenModule } from "../../../app/screen-module";
import { AgentDetailPage } from "../AgentPages";

export default {
	id: "end-user.agent-detail",
	path: "/app/agents/:ucsId",
	area: "end-user",
	label: "Agent詳細・依頼開始",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: AgentDetailPage,
} satisfies ScreenModule;
